/* unplugin-vue-components disabled */import { render } from "./MatchingQuestionEdit.vue?vue&type=template&id=8a92489a&scoped=true&ts=true"
import script from "./MatchingQuestionEdit.vue?vue&type=script&lang=ts"
export * from "./MatchingQuestionEdit.vue?vue&type=script&lang=ts"

import "./MatchingQuestionEdit.vue?vue&type=style&index=0&id=8a92489a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a92489a"]])

export default __exports__